import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../services/api';

const PrivateRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [authMethod, setAuthMethod] = useState(null);
  const location = useLocation();
  
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { isAuthenticated, authMethod: method } = await authService.checkAuthStatus();
        setIsAuthenticated(isAuthenticated);
        setAuthMethod(method || 'oauth');
      } catch (error) {
        console.error('Auth check failed:', error);
        setIsAuthenticated(false);
        setAuthMethod('oauth');
      }
    };
    
    checkAuth();
  }, []);
  
  if (isAuthenticated === null || authMethod === null) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  // Redirect org-token users away from restricted routes
  if (authMethod === 'org-token' && (location.pathname === '/droplets' || location.pathname === '/bandwidth')) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

export default PrivateRoute;